import { deepDaoLogoCircle } from '../assets/index';

export const organizationMock = {
  "data": {
    "id": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
    "name": "Example DAO",
    "description": "<p>This page illustrates the type of information DeepDAO Pro displayed for organizations. All data shown - names, personal, or DAO identifiers, token details, and any other fields - is purely illustrative. Nothing here is live, or associated with real entities or persons. Use it only as an example of the structure and features the platform provided.</p>",
    // "logo": null,
    "isInTop100": true,
    "proposalsCount": 305,
    "lifetimeParticipants": 15825,
    "membersCount": 92656,
    "aum": 10857272.021861967,
    "createdAt": "2021-06-02T17:02:18.157Z",
    "selfListingStatus": null,
    "website": "https://www.gitcoin.co/",
    "isDefaultPremium": true,
    "socials": [
      {
        "id": "e6a83a25-d642-4ea2-a460-f49e3b7b60f6",
        "type": "WEBSITE",
        "url": "https://www.gitcoin.co/"
      },
      {
        "id": "d26e8e0f-4b26-48fb-8ae9-7d23d7432ba0",
        "type": "TWITTER",
        "url": "https://x.com/gitcoin"
      },
      {
        "id": "607e9d91-95ab-4baa-b4ea-ead60899002a",
        "type": "DISCORD",
        "url": "https://discord.com/invite/gitcoin"
      },
      {
        "id": "bc9c2424-4518-4928-b93a-62d66b87f099",
        "type": "DISCOURSE",
        "url": "https://gov.gitcoin.co"
      },
      {
        "id": "c743bf82-6a8a-4993-b5cb-07d0d6f3c839",
        "type": "GITHUB",
        "url": "https://github.com/gitcoinco"
      },
      {
        "id": "f4a2fdc6-e796-4430-84d3-8b89b6a83f99",
        "type": "FORUM",
        "url": "https://community.gitcoin.co/"
      },
      {
        "id": "748e8347-cc96-4aec-bcaa-080c2644525e",
        "type": "OWN_BLOG",
        "url": "https://www.gitcoin.co/blog"
      },
      {
        "id": "8db8aa71-c11b-4a00-b67e-77cf5008b5d6",
        "type": "DOCUMENTATION",
        "url": "https://support.gitcoin.co/gitcoin-knowledge-base"
      },
      {
        "id": "dc22331e-a200-4c7d-9716-47b332582cbb",
        "type": "LINKEDIN",
        "url": "https://www.linkedin.com/company/getgitcoin"
      },
      {
        "id": "0c97fb08-e9e3-40cb-a525-b81a663857a7",
        "type": "LEGAL_ENTITY",
        "url": "https://cloudup.com/c5xGo4J5SXj"
      }
    ],
    "rankings": {
      "membersRankingPosition": 39,
      "membersRankingPositionShift": 0,
      "proposalsRankingPosition": 57,
      "proposalsRankingPositionShift": 0,
      "treasuryRankingPosition": 91,
      "treasuryRankingPositionShift": -1,
      "lifetimeParticipantsRankingPosition": 25,
      "lifetimeParticipantsRankingPositionShift": 0
    },
    "aumData": [
      {
        "name": "liquid",
        "value": 10857271.98
      },
      {
        "name": "vesting",
        "value": 0.04
      }
    ]
  }
};

export const execSummaryMock = {
  "treasuryDiversification": {
    "avgPercentage": 24.773937010085135,
    "treasuryDiversifcationAvgAsForMedium": 149.272,
    "diversificationPercentage": 61.75436515792778,
    "orgRank": 161,
    "orgRankInPercentage": 80
  },
  "tokenReliance": {
    "avgPercentage": 31.76699708454373,
    "tokenRelianceAsForMedium": 73.136,
    "orgRank": 112,
    "orgRankInPercentage": 55,
    "tokenReliancePercentage": 14.994867231558166
  },
  "activeDelegatesFor3Month": {
    "delegatesLast3Month": 37,
    "delegatesRankFor3MonthPercentage": 91,
    "delegatesRankFor3Month": 58
  },
  "missingVoters": {
    "numberOfMissingVoters": 9270,
    "missingVtsPercentagePerTokenHolders": 0.10004748748057331,
    "missingVotersRank": 41,
    "missingVotersRankPercentage": 64.51612903225806
  },
  "loyalVoters": {
    "numberOfLoyalVoters": 1195,
    "loyalVtsPercentagePerTokenHolders": 0.012897168019340356,
    "loyalVotersRankPercentage": 91.93548387096774,
    "loyalVotersRank": 58
  },
  "tokenPrice": {
    "orgsCount": 134,
    "priceGain": 13.40928756814094,
    "orgRank": 81,
    "updatedAt": "2025-10-01T22:00:09.376Z",
    "orgRankInPercentage": 60
  },
  "dominantCoalition": {
    "votingPower3MonthWinningPercentage": 63.1422377876738,
    "orgRank": 87,
    "orgRankInPercentage": 86,
    "countOfProOrganizations": 100,
    "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4"
  }
};

export const assetsMock = {
  "data": [
    {
      "type": "token",
      "address": "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
      "chainTitle": "Ethereum",
      "url": "https://etherscan.io/token/0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
      "description": "Gitcoin",
      "isSolana": false
    },
    {
      "type": "treasury",
      "address": "0x931896a8a9313f622a2afca76d1471b97955e551",
      "chainTitle": "Ethereum",
      "url": "https://etherscan.io/address/0x931896a8a9313f622a2afca76d1471b97955e551",
      "description": "Liquid",
      "isSolana": false
    },
    {
      "type": "treasury",
      "address": "0x44aa9c5a034c1499ec27906e2d427b704b567ffe",
      "chainTitle": "Ethereum",
      "url": "https://etherscan.io/address/0x44aa9c5a034c1499ec27906e2d427b704b567ffe",
      "description": "Vesting",
      "isSolana": false
    },
    {
      "type": "treasury",
      "address": "0xd4567069c5a1c1fc8261d8ff5c0b1d98f069cf47",
      "chainTitle": "Ethereum",
      "url": "https://etherscan.io/address/0xd4567069c5a1c1fc8261d8ff5c0b1d98f069cf47",
      "description": "Liquid",
      "isSolana": false
    },
    {
      "type": "treasury",
      "address": "0x57a8865cfb1ecef7253c27da6b4bc3daee5be518",
      "chainTitle": "Ethereum",
      "url": "https://etherscan.io/address/0x57a8865cfb1ecef7253c27da6b4bc3daee5be518",
      "description": "Liquid",
      "isSolana": false
    },
    {
      "type": "treasury",
      "address": "0xde21f729137c5af1b01d73af1dc21effa2b8a0d6",
      "chainTitle": "Ethereum",
      "url": "https://etherscan.io/address/0xde21f729137c5af1b01d73af1dc21effa2b8a0d6",
      "description": "Liquid",
      "isSolana": false
    },
    {
      "type": "treasury",
      "address": "0xd1f5d2a59ef194ae00f27b2da6599ce207dde7cb",
      "chainTitle": "Ethereum",
      "url": "https://etherscan.io/address/0xd1f5d2a59ef194ae00f27b2da6599ce207dde7cb",
      "description": "Liquid",
      "isSolana": false
    },
    {
      "type": "treasury",
      "address": "0x85e01c9e286a6b2bbc816cf862911572eaa34f04",
      "chainTitle": "Ethereum",
      "url": "https://etherscan.io/address/0x85e01c9e286a6b2bbc816cf862911572eaa34f04",
      "description": "Liquid",
      "isSolana": false
    },
    {
      "type": "treasury",
      "address": "0xa7ac9f7087d7197e0047db9a90562a1364bf897d",
      "chainTitle": "Ethereum",
      "url": "https://etherscan.io/address/0xa7ac9f7087d7197e0047db9a90562a1364bf897d",
      "description": "Liquid",
      "isSolana": false
    },
    {
      "type": "treasury",
      "address": "0x19e50fa5623895d5a2976693eaff5c2f879510ed",
      "chainTitle": "Ethereum",
      "url": "https://etherscan.io/address/0x19e50fa5623895d5a2976693eaff5c2f879510ed",
      "description": "Liquid",
      "isSolana": false
    },
    {
      "type": "treasury",
      "address": "0x5dd4721bb322499616d827be45c93f55d9181bc3",
      "chainTitle": "Ethereum",
      "url": "https://etherscan.io/address/0x5dd4721bb322499616d827be45c93f55d9181bc3",
      "description": "Liquid",
      "isSolana": false
    },
    {
      "type": "treasury",
      "address": "0xc23da3ca9300571b9cf43298228353cbb3e1b4c0",
      "chainTitle": "Ethereum",
      "url": "https://etherscan.io/address/0xc23da3ca9300571b9cf43298228353cbb3e1b4c0",
      "description": "Liquid",
      "isSolana": false
    },
    {
      "type": "treasury",
      "address": "0x20f6a812952818f424882ca8fd635e41656912d2",
      "chainTitle": "Ethereum",
      "url": "https://etherscan.io/address/0x20f6a812952818f424882ca8fd635e41656912d2",
      "description": "Liquid",
      "isSolana": false
    },
    {
      "type": "governance",
      "address": "gitcoingov.eth",
      "chainTitle": null,
      "url": "https://snapshot.org/#/gitcoingov.eth",
      "description": "Snapshot Governance",
      "isSolana": false
    },
    {
      "type": "governance",
      "address": "0x9d4c63565d5618310271bf3f3c01b2954c1d1639",
      "chainTitle": null,
      "url": "https://etherscan.io/address/0x9d4c63565d5618310271bf3f3c01b2954c1d1639",
      "description": "Governor",
      "isSolana": false
    },
    {
      "type": "governance",
      "address": "0xdbd27635a534a3d3169ef0498beb56fb9c937489",
      "chainTitle": null,
      "url": "https://etherscan.io/address/0xdbd27635a534a3d3169ef0498beb56fb9c937489",
      "description": "Governor",
      "isSolana": false
    },
    {
      "type": "governance",
      "address": "gitcoindao.eth",
      "chainTitle": null,
      "url": "https://snapshot.org/#/gitcoindao.eth",
      "description": "Snapshot Governance",
      "isSolana": false
    }
  ]
};

export const aumGraphMocked = {
  "data": [
    {
      "date": "2021-07",
      "month": 7,
      "aum": 76915903.79335515
    },
    {
      "date": "2021-08",
      "month": 8,
      "aum": 117884414.55880626
    },
    {
      "date": "2021-09",
      "month": 9,
      "aum": 97735864.83847345
    },
    {
      "date": "2021-10",
      "month": 10,
      "aum": 182295862.13127044
    },
    {
      "date": "2021-11",
      "month": 11,
      "aum": 184059481.258614
    },
    {
      "date": "2021-12",
      "month": 12,
      "aum": 88038150.05884285
    },
    {
      "date": "2022-01",
      "month": 1,
      "aum": 74022537.89527163
    },
    {
      "date": "2022-02",
      "month": 2,
      "aum": 67126075.0993617
    },
    {
      "date": "2022-03",
      "month": 3,
      "aum": 52018451.28427989
    },
    {
      "date": "2022-04",
      "month": 4,
      "aum": 49567981.265678056
    },
    {
      "date": "2022-05",
      "month": 5,
      "aum": 75540330.70049012
    },
    {
      "date": "2022-06",
      "month": 6,
      "aum": 71416227.92233759
    },
    {
      "date": "2022-07",
      "month": 7,
      "aum": 65879690.797487855
    },
    {
      "date": "2022-08",
      "month": 8,
      "aum": 67976447.16485143
    },
    {
      "date": "2022-09",
      "month": 9,
      "aum": 53022465.75917017
    },
    {
      "date": "2022-10",
      "month": 10,
      "aum": 51449093.33511827
    },
    {
      "date": "2022-11",
      "month": 11,
      "aum": 62106305.40249893
    },
    {
      "date": "2022-12",
      "month": 12,
      "aum": 59332489.76583894
    },
    {
      "date": "2023-01",
      "month": 1,
      "aum": 70593907.54549734
    },
    {
      "date": "2023-02",
      "month": 2,
      "aum": 91411213.2996824
    },
    {
      "date": "2023-03",
      "month": 3,
      "aum": 85852066.57262397
    },
    {
      "date": "2023-04",
      "month": 4,
      "aum": 83049289.5698631
    },
    {
      "date": "2023-05",
      "month": 5,
      "aum": 78389219.851546
    },
    {
      "date": "2023-06",
      "month": 6,
      "aum": 68966085.55739374
    },
    {
      "date": "2023-07",
      "month": 7,
      "aum": 63385280.35988879
    },
    {
      "date": "2023-08",
      "month": 8,
      "aum": 58680189.73469761
    },
    {
      "date": "2023-09",
      "month": 9,
      "aum": 53829499.09741322
    },
    {
      "date": "2023-10",
      "month": 10,
      "aum": 53939772.471758515
    },
    {
      "date": "2023-11",
      "month": 11,
      "aum": 60345861.44175756
    },
    {
      "date": "2023-12",
      "month": 12,
      "aum": 69413232.96280387
    },
    {
      "date": "2024-01",
      "month": 1,
      "aum": 69742368.29115538
    },
    {
      "date": "2024-02",
      "month": 2,
      "aum": 71618500.94335227
    },
    {
      "date": "2024-03",
      "month": 3,
      "aum": 107752193.48137707
    },
    {
      "date": "2024-04",
      "month": 4,
      "aum": 78944263.14181182
    },
    {
      "date": "2024-05",
      "month": 5,
      "aum": 72254734.73689012
    },
    {
      "date": "2024-06",
      "month": 6,
      "aum": 74990710.71065675
    },
    {
      "date": "2024-07",
      "month": 7,
      "aum": 57408112.439546205
    },
    {
      "date": "2024-08",
      "month": 8,
      "aum": 45184438.72531247
    },
    {
      "date": "2024-09",
      "month": 9,
      "aum": 38798314.73360795
    },
    {
      "date": "2024-10",
      "month": 10,
      "aum": 31157273.73235009
    },
    {
      "date": "2024-11",
      "month": 11,
      "aum": 41932766.81638221
    },
    {
      "date": "2024-12",
      "month": 12,
      "aum": 50105432.7696374
    },
    {
      "date": "2025-01",
      "month": 1,
      "aum": 41127097.65327772
    },
    {
      "date": "2025-02",
      "month": 2,
      "aum": 31352771.26089211
    },
    {
      "date": "2025-03",
      "month": 3,
      "aum": 19220980.023917627
    },
    {
      "date": "2025-04",
      "month": 4,
      "aum": 13936166.678796696
    },
    {
      "date": "2025-05",
      "month": 5,
      "aum": 13800669.597164216
    },
    {
      "date": "2025-06",
      "month": 6,
      "aum": 9904662.675695034
    },
    {
      "date": "2025-07",
      "month": 7,
      "aum": 9657472.237272572
    },
    {
      "date": "2025-08",
      "month": 8,
      "aum": 12042500.347420849
    },
    {
      "date": "2025-09",
      "month": 9,
      "aum": 11969667.513557393
    }
  ]
};

export const orgDaosMock = {
  "data": [
    {
      "daoId": "7dc34a38-66bd-48bc-b40e-16c04da71a75",
      "name": "Example DAO",
      "logo": null,
      "platform": 11,
      "platformTitle": "Snapshot",
      "website": "https://snapshot.org/#/gitcoindao.eth",
      "mostRecentProposalDate": "2025-09-16T18:06:14.000Z",
      "aum": null
    },
    {
      "daoId": "419a12fa-8877-4199-b2cf-25b8a46ab01e",
      "name": "Example DAO",
      "logo": null,
      "platform": 6,
      "platformTitle": "Governor",
      "website": null,
      "mostRecentProposalDate": "2025-05-27T14:20:47.000Z",
      "aum": 3548129.2293321765
    },
    {
      "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
      "name": "Example DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao/logo/6ccc01bb-6a94-41c8-895f-109638e43fb6.webp",
      "platform": 6,
      "platformTitle": "Governor",
      "website": "https://gitcoin.co/",
      "mostRecentProposalDate": "2023-08-10T08:28:35.000Z",
      "aum": 7309142.792529791
    },
    {
      "daoId": "4842f0bf-bac7-4f56-b2e6-0eee61222e16",
      "name": "Example DAO",
      "logo": null,
      "platform": 11,
      "platformTitle": "Snapshot",
      "website": "https://snapshot.org/#/gitcoingov.eth",
      "mostRecentProposalDate": "2023-04-12T05:07:30.000Z",
      "aum": null
    }
  ]
};

export const orgTabsMock = [
  {
    "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
    "tab": {
      "id": "e616b6a5-207f-4de0-a984-c6ea06b50f87",
      "name": "voter interests",
      "description": null
    },
    "isBlocked": false
  },
  {
    "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
    "tab": {
      "id": "fc4efadb-50de-46a0-b170-7ad5c5636564",
      "name": "voter trends",
      "description": null
    },
    "isBlocked": false
  },
  {
    "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
    "tab": {
      "id": "c33adecc-1a7c-409e-b682-8f9ff27c6c20",
      "name": "token",
      "description": null
    },
    "isBlocked": false
  },
  {
    "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
    "tab": {
      "id": "412a518c-a719-4b81-b978-01e2ad4e7988",
      "name": "delegates",
      "description": null
    },
    "isBlocked": false
  },
  {
    "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
    "tab": {
      "id": "89a929a8-c91b-4689-90e4-ca4c80a95260",
      "name": "treasury",
      "description": null
    },
    "isBlocked": false
  },
  {
    "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
    "tab": {
      "id": "44b0751a-8fa7-4462-b026-1094f08da965",
      "name": "coalitions",
      "description": null
    },
    "isBlocked": false
  },
  {
    "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
    "tab": {
      "id": "04917957-d8f2-4846-a8ec-6cac77cd0507",
      "name": "executive summary",
      "description": null
    },
    "isBlocked": false
  }
];

export const substormMock = [
  {
    "id": "77a0bd14-bdf8-4da2-a53c-b361516f9fb3",
    "title": "General",
    "description": null,
    "createdAt": "2022-08-09T10:23:32.488Z",
    "deepDaoDefault": true
  },
  {
    "id": "0075ebec-942f-4b09-834d-d5e3ff2d5447",
    "title": "Treasury",
    "description": null,
    "createdAt": "2022-08-09T10:23:32.488Z",
    "deepDaoDefault": true
  },
  {
    "id": "7501dbfa-5b20-417c-9175-d314dc331c45",
    "title": "Development",
    "description": null,
    "createdAt": "2022-08-09T10:23:32.488Z",
    "deepDaoDefault": true
  },
  {
    "id": "55e7f491-8a63-4120-99bc-8bcbae68a811",
    "title": "Marketing",
    "description": null,
    "createdAt": "2022-08-09T10:23:32.488Z",
    "deepDaoDefault": true
  },
  {
    "id": "2b382177-3730-4bb7-9db0-3c3a4d160bf4",
    "title": "DAO Business",
    "description": null,
    "createdAt": "2022-08-09T10:23:32.488Z",
    "deepDaoDefault": true
  },
  {
    "id": "d31c62e3-4c93-481c-a120-901642c04d5d",
    "title": "Signal",
    "description": null,
    "createdAt": "2022-08-09T10:23:32.488Z",
    "deepDaoDefault": true
  }
];

export const toolsMock = {
  "data": [
    {
      "id": "fa8ffd25-8164-4171-8ccf-0513740d239c",
      "name": "SubDAO",
      "logo": null,
      "mainUrl": "https://www.subdao.network/",
      "description": "SubDAO is a multi-chain DAO protocol for managing digital assets through signatures, voting, and decentralized features. It is set to provide widely applicable DAO tools in venture capital, serving fundraising, DeFi integrations for swaps, NFT trading, and liquidity lending."
    },
    {
      "id": "9dcbb660-ec00-4275-b769-c2d57c885951",
      "name": "Enzyme",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Enzyme.png",
      "mainUrl": "https://enzyme.finance//",
      "description": "Enzyme is a council-led DAO controlling the Enzyme protocol for assets management, that is based on ready-made and user-strategized investment vaults. It offers DAOs a set of flexible capabilities to run their treasuries, currently leaning towards high-risk DeFi."
    },
    {
      "id": "3f26c598-41db-457f-8e38-35e89cb704b8",
      "name": "Hats Finance",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/Hats_Finance.png",
      "mainUrl": "https://hats.finance/",
      "description": "Hats Finance is a decentralized bug bounty marketplace. It allows projects to create their native token bounty vaults, used to reward white hat hackers who successfully submit vulnerabilities in their codebase. Submissions are examined by the Hats` committee."
    },
    {
      "id": "bd4b7fd3-5226-4462-aa99-4b2e6062bf0b",
      "name": "DAOHause (Moloch)",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao-tools/DAOHause.png",
      "mainUrl": "https://daohaus.club/",
      "description": "DAOHause is Moloch DAOs' factory. Manufactured DAOs bear a set of minimaly viable functions, including ragequit, delegation and emergency. DAOHause is governed by holders of the HAUS token - moloch DAOs, their members and contributors."
    },
    {
      "id": "66b2fb15-1a2c-4f17-b524-bdccdafcb48f",
      "name": "ZenithBlocks",
      "logo": null,
      "mainUrl": "https://www.zenithblocks.com/",
      "description": "ZenithBlocks builds transparent financial management for DAOs. Currently in alpha testing (Aug. 2023), it is set to synchronize DAO proposals with DAO budgets, to allow their seamless, automated, custom budget lines, on-chain implementation, payments and invoices."
    }
  ]
};
